<template>
    <div class="error-message">{{ message }}</div>
</template>
<script>
export default {
    props: {
        message: {
            type: String
        }
    }
}
</script>
<style>
.error-message {
    color: crimson;
    padding-top: 0.5rem;
    margin-bottom: 0.5rem;
    font-size: 0.8rem;
}
</style>